import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/profile/')({
  beforeLoad: () => {
    throw redirect({ to: '/account' });
  },
});
